<block-ui [template]="blockTemplate">
  <app-header></app-header>
  <div class="application-padding-btm">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</block-ui>

<ng-template #blockTemplate>
  <div class="block-ui-template cssload-loader">
    <div class="circle">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
